"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("composer-lib/lib/utils");

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _ToggleButton = _interopRequireDefault(require("draft-plugins/components/ToggleButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var entityButtonBuilder = function entityButtonBuilder(_ref) {
  var style = _ref.style,
      mutable = _ref.mutable,
      icon = _ref.icon,
      options = _ref.options;

  var Button = function Button(_ref2) {
    var disabled = _ref2.disabled,
        editorState = _ref2.editorState,
        onChange = _ref2.onChange,
        onClick = _ref2.onClick,
        text = _ref2.text;

    var onToggle = function onToggle() {
      (0, _utils.callIfPossible)(onClick);
      var newEntityKey = null;

      if (!_draftExtend.pluginUtils.isEntityActive(editorState, style)) {
        var contentStateWithEntity = editorState.getCurrentContent().createEntity(style, mutable, options);
        newEntityKey = contentStateWithEntity.getLastCreatedEntityKey();
      }

      onChange(_draftJs.RichUtils.toggleLink(editorState, editorState.getSelection(), newEntityKey));
    };

    if (text) {
      return _react.default.createElement(_UIButton.default, {
        className: "beta-btn",
        onClick: onToggle,
        size: "small",
        use: "tertiary-light"
      }, _react.default.createElement(_UIIcon.default, {
        name: icon
      }), text);
    }

    return _react.default.createElement(_ToggleButton.default, {
      key: style,
      className: "toggle-" + style.toLowerCase(),
      active: _draftExtend.pluginUtils.isEntityActive(editorState, style),
      disabled: !disabled,
      icon: icon,
      onClick: onToggle
    });
  };

  Button.propTypes = {
    disabled: _propTypes.default.bool,
    editorState: _propTypes.default.instanceOf(_draftJs.EditorState).isRequired,
    onChange: _propTypes.default.func.isRequired,
    onClick: _propTypes.default.func,
    text: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.string])
  };
  return Button;
};

var _default = entityButtonBuilder;
exports.default = _default;
module.exports = exports.default;